module.exports = __webpack_public_path__ + "static/media/ramanujanLogo.931fd343.png";